import styled from 'styled-components';
import { MessageBase } from './message-base';

export const ErrorMessage = styled(MessageBase).attrs({
    className: String('ap-message-error')
})`
    color: ${({ theme: { message: { colors } } }) => colors.errorMessageColor};
`;
